import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { GameDataEditor } from './GameDataEditor'
import GameSheet from './GameSheet'
import { GameBoardProvider } from './components/GameBoard/GameBoardProvider'
import { PurchaseAssistProvider } from './components/PurchaseAssist'

export default () => {
  return (
    <Switch>
      <Route path="/game/:id/edit" component={GameDataEditor} />
      {/* Outermost so every in-game action hook — including the board
          provider's — can offer to cover a purchase the player is short for. */}
      <Route path="/game/:id" render={() => (
        <PurchaseAssistProvider>
          <GameBoardProvider>
            <GameSheet />
          </GameBoardProvider>
        </PurchaseAssistProvider>
      )} />
    </Switch>
  )
}
